import { createBooleanDevicePreference } from './devicePreference';

// Per-device "Health Connect wins for calories" toggle (HC-5 B4). When a
// session carries BOTH a measured HC calorie value and JL's own estimate, this
// decides which the read-time resolver (resolveWorkoutCalories) surfaces as
// canonical. Default ON — HC (sensor/3rd-party) is the more-entitled value when
// present; with no HC value the estimate always wins regardless. On-device only,
// no Profile sync — a display preference, not training data. Uses the shared
// factory so a Settings flip reaches an already-mounted calorie display without
// a remount (the same reactivity hints/effort-nudge need).
const pref = createBooleanDevicePreference('jl.hc.winsCalories.v1', true);

export const useHcWinsCalories = pref.usePreference;
